import(/* webpackMode: "eager", webpackExports: ["CurrencyDashboardClient"] */ "/app/app/(finance)/finance/currency-chart/CurrencyDashboardClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsDynamic"] */ "/app/app/components/BreadcrumbsDynamic.tsx");
